(() => {
  const initialize = () => {
    for (const root of document.querySelectorAll('.lm-stand-upsell[data-product-id]')) {
      if (root.dataset.addonsBound === 'true') continue;
      const productRoot = root.closest('.shopify-section')?.querySelector(
        `product-form-component[data-product-id="${root.dataset.productId}"]`
      );
      const form = productRoot?.querySelector('form[action*="/cart/add"]');
      const toggles = [...root.querySelectorAll('input[data-addon-variant-id]')];
      if (!form || !toggles.length) continue;
      root.dataset.addonsBound = 'true';
      const errorMessage = root.querySelector('.lm-stand-upsell__error');
      const submitAction = productRoot.getAttribute('on:submit');
      const updateState = () => {
        const selected = toggles.some((toggle) => toggle.checked && !toggle.disabled);
        // Horizon handles this attribute at document capture, before form listeners.
        // Let exactly one cart handler own each submission.
        if (selected) productRoot.removeAttribute('on:submit');
        else if (submitAction) productRoot.setAttribute('on:submit', submitAction);
        document.body.classList.toggle('lm-stand-addon-selected', selected);
        if (errorMessage) errorMessage.hidden = true;
      };
      for (const toggle of toggles) {
        toggle.checked = false;
        toggle.addEventListener('change', updateState);
      }
      updateState();
      let pending = false;
      form.addEventListener('submit', async (event) => {
        const selected = toggles.filter((toggle) => toggle.checked && !toggle.disabled);
        if (!selected.length) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        if (pending) return;
        pending = true;
        const button = event.submitter || form.querySelector('[type="submit"]');
        const originalContents = button?.innerHTML;
        if (button) {
          button.disabled = true;
          button.textContent = 'Adding…';
        }
        try {
          const data = new FormData(form);
          const quantity = Math.max(1, Math.floor(Number(data.get('quantity')) || 1));
          const base = { id: String(data.get('id') || root.dataset.baseVariantId), quantity };
          const properties = {};
          for (const [key, value] of data.entries()) {
            const match = key.match(/^properties\[(.*)\]$/);
            if (match && value !== '') properties[match[1]] = value;
          }
          if (Object.keys(properties).length) base.properties = properties;
          if (data.get('selling_plan')) base.selling_plan = data.get('selling_plan');
          const items = [base, ...selected.map((toggle) => ({ id: toggle.dataset.addonVariantId, quantity }))];
          const shopRoot = window.Shopify?.routes?.root || '/';
          const response = await fetch(`${shopRoot}cart/add.js`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items }),
          });
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || 'Unable to add the selected accessories. Please try again.');
          window.location.assign(`${shopRoot}cart`);
        } catch (error) {
          pending = false;
          if (button) {
            button.disabled = false;
            button.innerHTML = originalContents;
          }
          if (errorMessage) {
            errorMessage.textContent = error.message || 'Unable to add the selected accessories. Please try again.';
            errorMessage.hidden = false;
          }
        }
      }, true);
    }
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, { once: true });
  else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();
